<template>
    <div>
        <form class="xcard" @submit.prevent="validarCampos" style="margin-top:0;" novalidate>
            <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
            <h3 class="text-center"> Registrar Nuevo Contacto </h3>
            <p class="text-center text-primary" style="margin-bottom:0"> <small class="center-block"> <span class="glyphicon glyphicon-exclamation-sign"></span> Los campos con un asterisco <span class="text-danger">*</span> son obligatorios </small> </p>
            <div class="row">
                <div class="col-sm-6">
                    <p class="text-center text-primary"> <small>Datos obligatorios:</small> </p>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.nombres')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">*</span> Nombres</div>
                            <input type="text" v-model.trim="contacto.nombres" class="form-control" placeholder="Nombres del contacto">
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.nombres')"> {{validation.firstError('contacto.nombres')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.pri_apellido')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">*</span> Apellido 1</div>
                            <input type="text" v-model.trim="contacto.pri_apellido" class="form-control" placeholder="Primer apellido">
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.pri_apellido')"> {{validation.firstError('contacto.pri_apellido')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.seg_apellido')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Apellido 2</div>
                            <input type="text" v-model.trim="contacto.seg_apellido" class="form-control" placeholder="Segundo apellido">
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.seg_apellido')"> {{validation.firstError('contacto.seg_apellido')}} </div>
                    </div>
                    <div class="error" v-if="validation.hasError('contacto.telefono')"> Tel:{{validation.firstError('contacto.telefono')}} </div>
                    <!-- <AUserByPhone :model="contacto" :validation="validation"/> -->
                    <AUserByPhone :model="contacto" :validation="validation" v-on:eventBack="ifExistContact($event)"/>


                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('contacto.fecha_visita')}">
                            <div class="input-group-addon"> <span class="text-danger">*</span> Fecha de visita.</div>
                            <!-- <Fecha :model="contacto" :valueto="'fecha_visita'"/> -->
                            <Fecha :model="contacto" :valueto="'fecha_visita'" :default="contacto.fecha_visita"/>

                        </div>
                        <div class="error" v-if="validation.hasError('contacto.fecha_visita')"> {{validation.firstError('contacto.fecha_visita')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.idciudad')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">*</span> Ciudad</div>
                            <Ciudades :model="contacto"/>
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.idciudad')"> {{validation.firstError('contacto.idciudad')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.idprofesion')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">*</span> Profesion</div>
                            <Profesiones :model="contacto"/>
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.idprofesion')"> {{validation.firstError('contacto.idprofesion')}} </div>
                    </div>                    
                </div>

                <div class="col-sm-6">
                    <p class="text-center text-primary"> <small>Datos opcionales:</small> </p>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.direccion')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Direccion</div>
                            <input type="text" v-model.trim="contacto.direccion" class="form-control" placeholder="Donde vive el contacto">
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.direccion')"> {{validation.firstError('contacto.direccion')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.correo')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Correo </div>
                            <input type="text" v-model.trim="contacto.correo" class="form-control" placeholder="Email del contacto">
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.correo')"> {{validation.firstError('contacto.correo')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.idempresa')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Empresa </div>
                            <Empresas :model="contacto"/>
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.idempresa')"> {{validation.firstError('contacto.idempresa')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.observacion')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Observaciones </div>
                            <input type="text" v-model.trim="contacto.observacion" class="form-control" placeholder="Observaciones">
                        </div>
                        <div class="error" v-if="validation.hasError('contacto.observacion')"> {{validation.firstError('contacto.observacion')}} </div>
                    </div>


                    <hr>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.latitud')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Latitud: </div>
                            <input type="text" v-model.trim="contacto.latitud" class="form-control" placeholder="Latitud">
                        </div>
                        <div> <small class="text-primary">Obtener de <a href="#" @click="abrirMapa()" style="text-decoration:underline">Google Maps</a> </small> </div>
                        <div class="error" v-if="validation.hasError('contacto.latitud')"> {{validation.firstError('contacto.latitud')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('contacto.longitud')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> Longitud: </div>
                            <input type="text" v-model.trim="contacto.longitud" class="form-control" placeholder="Longitud">
                        </div>
                        <div> <small class="text-primary">Obtener de <a href="#" @click="abrirMapa()" style="text-decoration:underline">Google Maps</a> </small> </div>
                        <div class="error" v-if="validation.hasError('contacto.longitud')"> {{validation.firstError('contacto.longitud')}} </div>
                    </div>
                </div>
            </div>

            <Programas :model="contacto" :multiple="true"/>
            <div class="error" v-if="validation.hasError('contacto.intereses')"> Complete los intereses </div>


            <Alertas ref="alertar" />
            <p class="text-center"> {{msg}} </p>

            <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block"> <span class="glyphicon glyphicon-ok"></span> Aceptar </button>
        </form>
        <notifications group="auth" position="bottom right" />
    </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import gql from 'graphql-tag'
import Profesiones from '@/components/AProfesiones.vue' 
import Empresas from '@/components/AEmpresas.vue'
import Ciudades from '@/components/ACiudades.vue'
import Alertas from '@/components/AAlertas.vue'
import Fecha from '@/components/AFechaContacto.vue'
import Programas from '@/components/AProgramasContactos.vue' 
import AUserByPhone from '@/components/AUserByPhone.vue'
import {parseJsonError} from '@/components/Utils.js'
export default {
    data() {
        return {
            activo: true,
            msg: '',
            contacto:{
              nombres: null,
              pri_apellido: null,
              telefono: null,
              idciudad: null,
              idprofesion: null,
              fecha_visita: null,
              intereses:null,
              
              idempresa: null,
              observacion: null,
              direccion: null,
              correo: null,
              seg_apellido: null,
              latitud: null,
              longitud: null,
            }
            
        };
    },
    components:{Profesiones,Alertas,Ciudades,Fecha,Empresas,Programas,AUserByPhone},
    validators: {
        'contacto.nombres'(value){ return Validator.value(value).minLength(3).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$").required(); },
        'contacto.pri_apellido'(value){ return Validator.value(value).minLength(3).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$").required(); },
        'contacto.telefono'(value){ return Validator.value(value).digit().minLength(8).required(); },
        'contacto.idciudad'(value){ return Validator.value(value).required(); },
        'contacto.idprofesion'(value){ return Validator.value(value).required(); },
        // 'contacto.fecha_visita'(value){ return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$').required();},
        'contacto.intereses'(value){ return Validator.value(value).required(); },
        'contacto.seg_apellido'(value){ return Validator.value(value).minLength(3).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'contacto.correo'(value){ return Validator.value(value).email(); },

        'contacto.direccion'(value){ return Validator.value(value).minLength(5).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'contacto.observacion'(value){ return Validator.value(value).minLength(5).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'contacto.latitud'(value){ return Validator.value(value).minLength(0).regex("^(-?\\d+(\\.\\d+)?)$"); },
        'contacto.longitud'(value){ return Validator.value(value).minLength(0).regex("^(-?\\d+(\\.\\d+)?)$"); },
    },
    watch:{
        contacto:{
            deep: true,
            handler( a ){
                window.sessionStorage.setItem( 'xcontacto',JSON.stringify(a) )
            }
        }
    },
    methods:{
        abrirMapa(){
            window.open('https://maps.google.com/?q=-16.864994,-67.0586188&ll=-16.864994,-67.0586188&z=6');
        },
        validarCampos(){
            this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.contacto );
                if( obj.intereses ){
                  var intereses = [];
                    obj.intereses.forEach( function(e){
                      intereses.push( {idpostgrado:e.idpostgrado,tipo:"T"} )
                    });
                    obj.intereses = intereses;
                }
                if (success) {
                    //obj.idciudad = obj.idciudad.id;
                    //obj.idprofesion = obj.idprofesion.id;
                    if( obj.idempresa ) obj.idempresa = obj.idempresa.id;
                    if( obj.idciudad ) obj.idciudad = obj.idciudad.id;
                    if( obj.idprofesion ) obj.idprofesion = obj.idprofesion.id;
                    if( obj.latitud ) obj.latitud = parseFloat( obj.latitud );
                    if( obj.longitud ) obj.longitud = parseFloat( obj.longitud );
                    this.$store.state.obj = obj;
                    this.$store.dispatch('quitarNulos');

                    this.activo = false;
                    this.$refs.alertar.cargando();
                    // window.console.log( "SSSSS",window.stringifyObject(obj) );
                    this.enviarDatos( obj );
                }else{
                    // window.console.log( "HHHHH",window.stringifyObject(obj) );
                    this.$refs.alertar.invalido();
                }
            });
        },
        async enviarDatos( obj ){
            var vue = this;
            var sql = gql`mutation{ createContacto(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
            vue.msg = '';
            // window.console.log( sql );

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                if(data.data.createContacto.ok){
                    vue.$refs.alertar.success();
                    window.sessionStorage.removeItem( 'xcontacto' )
                    setTimeout(function(){
                      vue.$router.push("/contactos");
                    },2000)
                }else{
                    var errores = JSON.stringify(data.data.createContacto.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
                
                // window.console.log(data);
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(window.stringifyObject(error));
                this.$notify( parseJsonError( error,'createContacto' ) )
            })

        },
        ifExistContact(payload){
            const {ifExist, fecha} = payload;
            this.activo = !ifExist
            if (fecha) {
                let d = new Date(fecha)
                d.setMonth(d.getMonth() + 1);
                if (d < new Date())
                    this.activo = !this.activo
            }
        },
        // METODO QUE OBTENGA LOS CONTACTOS CON EL TELEFONO UNICO, SI EXISTE ESE REGISTRO ENTONCES YA NO DEBE PERMITIR, 
        // SI EXISTE ENTONCES Y PASO  MES, ENTONCES DEBE PERMITIR REGISTRAR ALA NUEVO ASESOR
    },
    mounted(){
        /*var xc = window.sessionStorage.getItem( 'xcontacto' );
        if( xc ){
            var xcc = JSON.parse( xc );
            if( xcc ) this.contacto = xcc;
        }*/
        var date = new Date();
        var dia = date.getDate();
        var mes = date.getMonth()+1;
        if( dia == 1 ) dia = 2;
        if( dia < 10 ) dia = '0'+dia;
        if( mes < 10 ) mes = '0'+mes;
        this.contacto.fecha_visita = date.getFullYear()+"-"+mes+"-"+dia;
    },
}
</script>